import { render, staticRenderFns } from "./SalesApprovalEdit.vue?vue&type=template&id=3c165e54&scoped=true"
import script from "./SalesApprovalEdit.vue?vue&type=script&lang=js"
export * from "./SalesApprovalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c165e54",
  null
  
)

export default component.exports